export const englishTranslations = {
    translations: {
        accessibility: 'ACCESSIBILITY',
        analytics: {
            api: 'APIs',
            equities: 'Equities',
            foreignExchange: 'Foreign Exchange',
            futures: 'Futures',
            index: 'Index Analytics',
            loginFlow: 'alternative',
            loginTitle: 'Multi-Asset Trade Analytics',
            mataLogo: 'MATA logo',
            welcomeHeaderDesc: 'Designed to help make informed trading decisions in today\'s complex and rapidly evolving markets. Discover our evolving cross-asset capabilities throughtout the trade lifecycle to drive impactful execution strategies.',
            welcomeHeaderDescTop: 'Multi-Asset Trade Analytics',
            welcomeHeaderTitle: 'Welcome to'
        },
        appInactive: {
            content: 'The application you are trying to access is inactive at this moment. Please retry later.',
            title: 'Application Inactive'
        },
        appMaintenance: {
            content: 'The application you are trying to access is under maintenance. Please retry later.',
            title: 'Application In Maintenance'
        },
        ariaLabel: {
            rbcLogo: 'Link to RBC Capital Markets home'
        },
        authenticationError: 'Authentication Error',
        authenticatorOptions: {
            'Access your login code in the Google Authenticator app': 'Access your login code in the Google Authenticator app',
            'Access your login code in the Okta Verify app': 'Access your login code in the Okta Verify app',
            'Google Authenticator': 'Google Authenticator',
            'Launch Google Authenticator, tap the "+" icon, then select "Enter a setup key". Input the following in the key field.': 'Launch Google Authenticator, tap the "+" icon, then select "Enter a setup key". Input the following in the key field.',
            'Launch Google Authenticator, tap the "+" icon, then select "Scan QR code".': 'Launch Google Authenticator, tap the "+" icon, then select "Scan QR code".',
            'Launch Okta Verify application, tap the "+" icon, select "Organization" to add account. Select "Yes, Ready to Scan", then select "Enter Key Manually" and input the following in the key field.': 'Launch Okta Verify application, tap the "+" icon, select "Organization" to add account. Select "Yes, Ready to Scan", then select "Enter Key Manually" and input the following in the key field.',
            'Launch Okta Verify, tap the "+" icon, then select "Organization" to add account, then scan the QR code.': 'Launch Okta Verify, tap the "+" icon, then select "Organization" to add account, then scan the QR code.',
            'Multifactor - Google Authenticator': 'Setup Multi-Factor Google Authenticator',
            'Multifactor - Okta Verify with Code': 'Setup Multi-Factor Okta Verify with Code',
            'Multifactor - Okta Verify with Push': 'Setup Multi-Factor Okta Verify with Push',
            'Okta Verify will send a push notification to your mobile device': 'Okta Verify will send a push notification to your mobile device',
            'Okta Verify with Code': 'Okta Verify with Code',
            'Okta Verify with Push': 'Okta Verify with Push',
            optionalMfaTitle: {
                'Multifactor - Google Authenticator': 'Multi-Factor Google Authenticator',
                'Multifactor - Okta Verify with Code': 'Multi-Factor Okta Verify with Code',
                'Multifactor - Okta Verify with Push': 'Multi-Factor Okta Verify with Push',
            },
            'Please check Okta Verify application on your mobile device to accept the login push notification request.': 'Please check Okta Verify application on your mobile device to accept the login push notification request.',
            'Select your type of device to set up Google Authenticator.': 'Select your type of device to set up Google Authenticator.',
            'Select your type of device to set up Okta Verify.': 'Select your type of device to set up Okta Verify.',
            'Thanks for selecting Google Authenticator. \n\nOpen the Google Authenticator app on your phone. \nClick the "+" button to add a new RBC Capital Markets online portal account.\nChoose "Scan a QR code" option to scan the QR code below.': 'Thanks for selecting Google Authenticator. \n\nOpen the Google Authenticator app on your phone. \nClick the "+" button to add a new RBC Capital Markets online portal account.\nChoose "Scan a QR code" option to scan the QR code below.',
            'Thanks for selecting Okta Verify. \n\nOpen the Okta Verify app on your phone. \nClick the "+" button to add a new RBC Capital Markets online portal account.\nChoose "Scan a QR code" option to scan the QR code below.': 'Thanks for selecting Okta Verify. \n\nOpen the Okta Verify app on your phone. \nClick the "+" button to add a new RBC Capital Markets online portal account.\nChoose "Scan a QR code" option to scan the QR code below.',
            'To setup manually enter your Google Authenticator Account username and then input the following in the Secret Key field': 'To setup manually enter your Google Authenticator Account username and then input the following in the Secret Key field',
            'To setup manually enter your Okta Account username and then input the following in the Secret Key field': 'To setup manually enter your Okta Account username and then input the following in the Secret Key field',
        },
        authenticators: {
            'Google Authenticator': 'Enter the code displayed in your Google Authenticator app.',
            'Okta Verify': 'Enter the code displayed in your Okta Verify app.',
            verbiage01: 'Please select your preferred MFA provider from the list of options. ',
            verbiage02: 'Configure additional factors or finish for now.',
            verbiage1: 'We offer Multifactor authentication (MFA) to provide additional security. We strongly encourage the use of MFA. You will have an opportunity to enroll into MFA at later time.',
            verbiage2: 'If you would like to enroll for MFA, please click',
            verbiage3: 'If you prefer to skip this step, please click',
            verbiage4: 'You can configure additional factors or click',
            verbiage5: 'You will need to install an authenticator app from your phone&#39s app store.',
            verbiage6: 'Please click',
            verbiage7: 'beside the app you would like to use.',
            verbiage8: 'Please select your preferred MFA provider from the list of options. Click <i>Setup</i> button on the right to enroll. Please click <i>Finish</i> if you would like to skip it at this time.'
        },
        back: 'Back',
        button: 'button',
        call: 'CALL',
        cantScan: 'Can\'t scan?',
        cantScanQRCode: 'Can\'t scan QR code?',
        cnb: {
            ariaLabelLogo: 'Link to RBC Capital Markets home',
            footerCopyright: 'City National Bank. All Rights Reserved.',
            footerVerbiage: 'If you\'re not registered with us, please contact your City National Bank Relationship Manager.',
            loginTitle: 'DX Sign In',
            logo: '/img/city-national-bank-logo.svg?url',
            logoUrl: 'https://www.rbccm.com/en/',
            privacyCNB: 'The City National DX service is operated by RBC Capital Markets. By logging in, you acknowledge that you have read and agree to the terms of the ',
            privacyPolicy: 'Privacy Policy',
            privacyUrl: 'https://www.cnb.com/privacy-security.html',
            termsandConditions: 'Terms and Conditions.',
            termsandConditionsUrl: 'https://www.cnb.com/privacy-security/terms-conditions.html',
            wrappertext: 'and the'
        },
        code: 'Code',
        comq: {
            loginTitle: 'RBC CommissionQ'
        },

        countryCodeRequired: 'Country code is required',
        deviceType: {
            scan1: 'Scan the QR code or ',
            scan2: 'go to ',
            scan3: ' to download {{appName}} on your {{deviceType}} device.',
            verbiage1: 'Please Download {{appName}}',
            verbiage1: 'Download {{appName}}',
            verbiage2: 'from the ',
            verbiage3: 'on to your mobile device.'
        },
        deviceTypeNew: {
            verbiage1: 'Scan the QR code or',
            verbiage2: 'go to',
            verbiage3: 'to download {{appName}} on your {{deviceType}} mobile device.'
        },
        email: 'Email',
        enroll: 'Enroll',
        enrolled: 'Enrolled',
        errorPage: {
            error: 'Error',
            helpText: 'If you need help, please contact your RBC sales representative.',
            linkExpiredMessage: 'The forgot password link is not valid or expired. For your security, password reset links only work for a limited time.\nPlease return to the login page and request a new password reset link.',
            linkExpiredTitle: 'Password Reset Link Expired',
            returnToLogin: 'Return to login'
        },
        failedPolicy: {
            content: 'You do not have access to this application.',
            title: 'No Application Access'
        },
        finish: 'Finish',
        footer: {
            accessibility: 'ACCESSIBILITY',
            accessibilityLink: 'http://www.rbccm.com/en/accessibility.page',
            cipf: 'Member - Canadian Investor Protection Fund',
            cipfLink: 'https://www.ciro.ca/',
            ciroSrc: '/img/CIRO_logo_en.svg?url',
            ciroSrcdark: '/img/CIRO_logo_en_light.svg?url',
            ciroSrclight: '/img/CIRO_logo_en.svg?url',
            footerText: '© RBC Dominion Securities Inc. 2001, 2003, 2010 rbccm.com is an online information service operated by RBC Dominion Securities Inc. and the other businesses and legal entities operating under the brand name RBC Capital Markets.',
            legalDisclaimer: 'LEGAL & DISCLAIMERS',
            legalDisclaimerLink: 'http://www.rbccm.com/en/policies-disclaimers.page',
            privacy: 'PRIVACY',
            privacylink: 'https://www.rbc.com/privacysecurity/ca/index.html'
        },
        forgotPw: 'Forgot Password?',
        forgotPwd: 'Reset Password',
        forgotPwdFlow: {
            criteriaMainTitle: 'Your password must:',
            enterYourCode: 'Enter your code',
            forgotPwdButtonVerbiage: 'Reset Password',
            forgotPwdVerbiage: 'Please click Reset Password to update the password for your account.',
            helpText: 'If you need help, please contact your RBC sales representative.',
            resendResetLink: 'RESEND RESET LINK',
            resendVerificationCode: 'Resend Verification Code',
            selectVerificationMethod: 'Please select how you want to verify yourself today.',
            step1Description: 'Have your phone ready to receive a verification code.',
            step1Title: 'Verify your identity',
            step2Description: 'Create a strong new password.',
            step2Title: 'Set a new password',
            subtitle: 'Reset your password in 2 steps',
            successMessage: 'Log in to the RBC Digital Marketplace with your new credentials',
            successSubMessage: 'Or use the quick link to launch your app directly ',
            successTitle: 'Password updated successfully!',
            supportText: 'Note: We\'ll also verify your password isn\'t too easy to guess and hasn\'t been used before.',
            verification: 'Verification',
            verificationCode: 'Verification Code',
            verifyVerbiage: 'We have contacted you via {{recoveryType}} to deliver a verification code to the following number {{phoneNumber}}{{phoneExtension}}.\n Please enter the code below.', 
            warningMessage: 'This link can be used only once. Please make sure you are ready to complete the process before selecting Next.'          
        },
        frenchInfo: 'En anglais seulement',
        magicLink: {
            continueButton: 'CONTINUE',
            linkExpired: 'Link Expired',
            supportText: 'Please click Continue to proceed with the login.',
            title: 'Log In with Email',
            //  title: 'Magic Link Login',
            tooManyRequests: 'You recently requested an email from us, please check your mailbox. If you don\'t see it, please resubmit a request or \'request access\' using the button below.',
            verbiage: 'Click the button below to continue.'        
            
        },
        hedgex: {
            cardDescription: 'HedgeX is a custody-based platform offered by the Royal Bank of Canada\'s Alternative Assets Group (AAG) that provides hedge fund investors the ability to use their assets as collateral for liquidity facilities, leverage and hedging instruments. The service presents an unparalleled level of convenience and flexibility in managing alternative investment portfolios.',
            cardTitle: 'Unlock Full Portfolio Potential',
            copyright: '© 2005-2025 Royal Bank of Canada. www.rbchedgex.com is an online service operated by RBC Capital Markets, LLC',
            digitalMarketplace: 'Digital Marketplace',
            emailLabel: 'Email:',
            login: 'Log In',
            needAssistance: 'Need assistance?',
            poweredBy: 'Powered by',
            telephoneLabel: 'Telephone:',
            welcome: 'WELCOME TO',
        },
        aag: {
            cardDescription: 'The Alternative Assets Group (AAG) is a unit within RBC Capital Markets dedicated to providing customized products and services to hedge fund investors. The group combines its expertise in hedge fund structured products with the custodial services of the <portfolioLink>Portfolio Services Group</portfolioLink> and the capabilities of the <rbcLink>RBC Financial Group</rbcLink>. These collective services create a unique platform, allowing us to develop and execute tailored products to meet the sophisticated Investment objectives of our counterparties.',
            cardTitle: 'Customize your investment Strategy',
            copyright: '© 2001-2026 Royal Bank of Canada. www.alternativeassets.com is an online service operated by RBC Capital Markets, LLC',
            digitalMarketplace: 'Digital Marketplace',
            emailLabel: 'Email:',
            login: 'Log In',
            loginTitle: 'AAG - Log In',
            logoName: 'Alternative Assets',
            needAssistance: 'Need assistance?',
            privacy: 'Privacy',
            poweredBy: 'Powered by',
            taglineLine1: 'Precision.',
            taglineLine2: 'Customization.',
            taglineLine3: 'Results.',
            telephoneLabel: 'Telephone:',
            welcome: 'WELCOME TO',
            welcomeHeaderDesc: 'Please login to connect with AAG.',
            welcomeHeaderDescTop: 'Alternative Assets Group',
            welcomeHeaderTitle: 'Welcome to \n',
        },
        requestAccess: {
            mataCapabilitiesLabel: 'Select MATA capabilities (optional):',
            addDealerCode: 'Add Dealer Code',
            selected: 'Selected',
            backToHome: 'Back to Home',
            cancel: 'Cancel',
            companyname: 'Company Name',
            countryCode: 'Country Code',
            dealerCode: 'Dealer Code',
            dealerCodeInvalid: 'Must be 4 digits',
            dealerCodePlaceholder: 'e.g. 1234',
            dealerCodeRequired: 'Dealer code is required',
            dealerCodeTooltip: 'Your firm\'s 4-digit identifier in the FundServ ID.',
            dealerCodeUnique: 'Dealer code has to be unique',
            dealerRepInstruction1: 'To set up your access, provide your Dealer Code and Rep Code(s). These work as a pair: each Dealer Code must be linked to at least one Rep Code.',
            dealerRepInstruction2: 'Don\'t have your codes? Contact your firm\'s operations team or look up your Dealer Code',
            dealerRepInstruction3: 'at',
            dealerRepSubtitle: 'Enter your Dealer Code(s) and associated Rep Code(s). Enter multiple rep codes separated by commas.',
            dealerRepTitle: 'Dealer Code / Rep Code(s)',
            email: 'Email',
            enterInformationVerbiage: 'Please provide your details to complete your access request.',
            ext: 'Ext#',
            firstname: 'First Name',
            fundservLink: 'FundServ Member Registry',
            language: 'Preferred Language',
            lastname: 'Last Name',
            maxLength255: 'Maximum 255 characters allowed.',
            phonenumber: 'Phone Number',
            repCodes: 'Rep Code(s)',
            repCodesInvalid: 'Rep codes must be 2–5 alphanumeric characters',
            repCodesPlaceholderShort: 'e.g. ABC1',
            repCodesRequired: 'At least one rep code is required',
            repCodesTooltip: 'Your advisorID(s) (usually a combination of letters and numbers).',
            repCodesPlaceholder: 'e.g. AB, CD1',
            removeDealerCode: 'Remove dealer code row',
            dealerRepRowRemoved: 'Item successfully deleted',
            stepEnterInformation: 'Enter your information',
            stepSelectProducts: 'Select Products',
            selectProductsSubtitle: 'Choose one or more products to begin your access request.',
            stepReviewSubmit: 'Review & Submit',
            reviewSubtitle: 'Please review your access request before submitting.',
            selectedProducts: 'Selected Products',
            editSelection: 'Edit Selection',
            mataCapabilitiesReview: 'MATA capabilities',
            submit: 'Submit',
            success: 'Request Submitted!',
            successVerbiage1: 'Thank you for your interest in RBC Capital Markets Products. We will review your request.',
            successVerbiage2: 'If you do not receive a response, please reach out to your RBC Coverage.',
            completeHighlightedFields: 'Please complete the highlighted fields above before continuing.',
            backToSignIn: 'BACK TO SIGN IN',
            cancelRequestTitle: 'Cancel access request',
            cancelRequestBody1: 'You are about to cancel your access request.',
            cancelRequestBody2: 'If you cancel all the information entered will be lost.',
            cancelRequestBack: 'BACK',
            cancelRequestConfirm: 'CANCEL REQUEST'
        },
        incorrectEmail: 'Incorrect email format',
        rbcEmail: 'Please use a non RBC email',
        incorrectlanguage: 'Please select a preferred language',
        incorrectPhoneNumber: 'Incorrect phone number format',
        language: {
            English: 'English',
            French: 'French',
        },
        legalDisclaimer: 'LEGAL & DISCLAIMERS',
        letsGetStarted: 'Get Started',
        loading: 'Loading...',
        login: 'Log in',
        loginButton: 'Login Here',
        loginFlow: {
            accountRecovery: {
                enterVerificationCode: 'Enter your code',
                errorMessage: 'Incorrect Verification Code',
                resendCode: 'Resend Code',
                resendVerificationCode: 'Resend Verification Code',
                verbiage: 'We have sent an {{recoveryType}} code to {{phoneNumber}} to verify your identity. \n Please enter the code below.',
                verification: 'Verification',
                verificationCall: 'CALL Verification',
                verificationCode: 'Verification Code',
                verificationSMS: 'SMS Verification',
                verificationVerbiage: 'We have sent an {{recoveryType}} code to {{phoneNumber}} to verify your identity. \n Please enter the code below.',
                verificationVerbiageCall: 'We have contacted you via {{recoveryType}} to deliver a verification code to the following number {{phoneNumber}} to verify your identity. \n Please enter the code below.',
                verified: 'Verification successful!'
            },
            authenticatorCode: {
                button: 'button',
                stepVerbiage: 'Enter the code displayed in {{verbiage}} app.'
            },
            push: {
                resendMessagePushSucess: 'Push notification has been resent'
            }
        },
        loginText: 'Log In',
        logoutSuccess: {
            content: 'You have successfully logged out of RBC Capital Markets Client Portal.\n\nPlease use the following link to login again.',
            title: 'Logout Successful'
        },
        main: {
            loginTitle: 'RBC CM Online'
        },
        mfa: 'Multi-Factor Authentication (MFA)',
        
        mfaEnrollment: {
            deviceSelection : 'Please select your preferred MFA provider from the list of options.',
            enable: 'Enable now',
            gotp: 'Launch Google Authenticator, tap the "+" icon, then select "Scan QR code".',
            introTitle: 'Multi-factor authentication (MFA) adds an extra layer of protection to your account. \nAfter entering your password, you\'ll use an app on your phone to verify it\'s really you.',
            'notScanGotp': 'Launch Google Authenticator, tap the "+" icon, then select "Enter a setup key”. Input the following in the key field.',
            'notScanOotp':'Launch Okta Verify application, tap the "+" icon, select “Organization” to add account. Select "Yes, Ready to Scan", then select "Enter Key Manually" and input the following in the key field.',
            'notScanOpush':'Launch Okta Verify application, tap the "+" icon, select “Organization” to add account. Select "Yes, Ready to Scan", then select "Enter Key Manually" and input the following in the key field.',
            ootp: 'Launch Okta Verify application, tap the "+" icon, select “Organization” to add account, then scan the QR code.',
            opush: 'Launch Okta Verify application, tap the "+" icon, select “Organization” to add account, then scan the QR code.',
            setupLater: 'Set up later',
            skip: 'Skip',
            verbiage01:'Multi-factor authentication (MFA) adds an extra layer of protection to your account. \n After entering your password, you\'ll use an app on your phone to verify it\'s really you.',
            verbiage02: 'Here is what to expect:',
            verbiage03: 'Download Google Authenticator or Okta Verify',
            verbiage04: 'Scan a QR code to link it to your account',
            verbiage05: 'Use the app to verify your identity on future logins',
            verbiage06: 'Takes about<bold>a few minutes.</bold>',
            verbiage061: '<strong> a few minutes.</strong>',
            verbiage07: 'If you need help, please contact your RBC sales representative.',
            verbiage1: 'MFA provides you with enhanced security. It requires an extra verification factor in addition to your password.',
            verbiage2: 'If you would like to enroll for MFA, please click',
            verbiage3: 'If you prefer to skip this step, please click',
            verbiage4: 'Do not ask me again for 30 days',
            verbiage5: 'If you choose to skip this step now, you will have an opportunity to enroll at a later time.'
        },
        mfaRecommendedSubText:'Takes about <strong> a few minutes.</strong>',
        mfaSetUp: 'ENABLE NOW',
        mfaSetupLater: 'SET UP LATER',
        mfaSetUpText: 'SET UP',
        mfaSubText : 'Takes about <strong> a few minutes.</strong> You can also enable this later from your account settings.',
        mfaTitle: 'Recommended: Multi-Factor Authentication (MFA)',
        mfd: {
            informationLinkName: 'click here',
            loginTitle: 'RBC Money Funds Direct',
            welcomeHeaderDesc: 'Your source for comprehensive research, analysis and cash investing. \n For more information please ',
            welcomeHeaderDescTop: 'For US Investors Only',
            welcomeHeaderTitle: 'RBC Money Funds Direct ',
            welcomeHeaderTitleItalic: '— Transparency on Demand'
        },
        ML_SUCCESS: 'If we have your email on file, you will receive \n an email with a one-time log in link.  If you do not receive an email, please request access.',
        moreInfo: 'For more information, please contact your RBC Sales Representative.',
        needHelp: 'Need Help?',
        next: 'Next',
        noAccess: {
            loginHere: 'Login Here',
            title: 'No Access',
            title1: 'Authentication Error',
            verbiage01: 'Apologies. A set up error is preventing you from logging in.\nPlease contact your RBC sales representatives for assistance.',
            verbiage1: 'You should log in from',
            verbiage2: '\n Please proceed to login by clicking on the link here.'
        },
        oktaApiResponse: {
            '407 - Proxy Authentication Error': '407 - Proxy Authentication Error',
            '407 Proxy Error!': 'Proxy Error!',
            'A phone call was recently made. Please wait 30 seconds before trying again.': 'A phone call was recently made. Please wait 30 seconds before trying again.',
            ACCOUNT_RECOVERY_NOT_ACTIVE: 'Apologies, a setup issue is preventing you from logging in. Please contact your RBC Salesperson for assistance.',
            'Already in Okta': 'Already in Okta',
            'An SMS message was recently sent. Please wait 30 seconds before trying again.': 'An SMS message was recently sent. Please wait 30 seconds before trying again.',
            'Authentication Error. Password may be incorrect.': 'Authentication Error. Password may be incorrect.',
            cancelError: 'Cannot cancel request.',
            'Cannot Migrate Internal Users': 'Cannot Migrate Internal Users',
            'Cannot Proceed. Account Recovery has not been setup.': 'Cannot Proceed. Account Recovery has not been setup.',
            'connection error': 'Connection error',
            'Each code can only be used once. Please wait for a new code and try again.': 'Each code can only be used once. Please wait for a new code and try again.',
            errorInvalidCode: 'Invalid Code.',
            errorInvalidPasscode: 'Invalid Verification Code.',
            'For security reason your last request has been blocked. [SDC5178 BD 1]': 'There was an error processing this request. Please contact the administrator for assistance.',
            'For security reason your last request has been blocked. [SDC5178 BD 2]': 'There was an error processing this request. Please contact the administrator for assistance.',
            'For security reason your last request has been blocked. [SDC5178 BD 3]': 'There was an error processing this request. Please contact the administrator for assistance.',
            forgotPasswordError: 'There is an error resetting the password. Please note, you can only reset your password once a day.',
            forgotPasswordRequest: 'An email has been sent to help you reset your password. Please check your email.',
            incompleteUserData: 'This request could not be submitted. Incomplete user data: {0}. Please contact Digital Channels support team (CM-IT-WebSupport@rbc.com) for this issue.',
            insufficientPermissions: 'User has insufficient privileges.',
            invalidParameters: 'Bad Request.',
            'Log DB: Error Creating Database Entry': 'Log DB: Error Creating Database Entry',
            MFA_ENROLL: 'Apologies, a setup issue is preventing you from logging in. Please contact your RBC Salesperson for assistance.',
            'Missing profile fields in WSS': 'Missing profile fields in WSS',
            'No Email Recepients Found.': 'No Email Recepients Found.',
            'No matching records found.': '"No matching records found.',
            'Not active in WSS': 'Not active in WSS',
            'Push request has been terminated.': 'Push request has been terminated.',
            'Password less token is invalid or expired.':'Your login link is not valid or expired.\n For your security, login links only work for 1 hour.\n Return to login page to request a new link.',
            pwReset: 'Password Reset',
            recoveryTokenError: 'The recovery token is not valid.',
            requestTimeout: 'Request has timed out. Please try narrowing down your search.',
            SDC5178_BD_1: 'For security reason your last request has been blocked. [SDC5178:BD:1]',
            SDC5178_BD_2: 'For security reason your last request has been blocked. [SDC5178:BD:2]',
            SDC5178_BD_3: 'For security reason your last request has been blocked. [SDC5178:BD:3]',
            SDC5178_BD_4: 'For security reason your last request has been blocked. [SDC5178:BD:4]',
            somethingWentWrong: 'We encountered an unexpected error while processing your request.\n We apologize for the inconvenience.\n Please request a new link or contact your RBC sales representatives for assistance if this issue persists. ',
            standardErrorMessage: 'There was an error processing this request. Please contact the administrator for assistance.',
            'The password does not meet the complexity requirements of the current password policy.': 'The password does not meet the complexity requirements of the current password policy.',
            'There was an error processing this request. Please contact the administrator for assistance.': 'There was an error processing this request. Please contact the administrator for assistance.',
            'This password is too easy to guess. Try adding more variety with different character types or a longer combination.':'This password is too easy to guess.\n Try adding more variety with different character types or a longer combination.',
            tokenExpired: 'Token has been invalidated.',
            'Unable to change password.': 'Unable to change password.',
            'Unable to proceed. Invalid Session': 'Unable to proceed. Invalid Session',
            'Unable to process this request. This user has already been assigned to this application and role.': 'Unable to process this request. This user has already been assigned to this application and role.',
            unauthorized: 'Authentication Error.',
            unauthorizedActivationToken: 'The activation link that you provided is not valid or expired.',
            unauthorizedRecoveryToken: 'The forgot password link is not valid or expired. For your security, password reset links only work for a limited time. Please return to the login page and request a new password reset link.',
            'User has insufficient privileges.': 'User has insufficient privileges.',
            'User Not Authorized.': 'User Not Authorized.',
            'User not found.': 'User not found.',
            'We were unable to validate the code you have provided. Please retry.': 'We were unable to validate the code you have provided. Please retry.',
            'We\'ve recently sent a password reset request. Please check your mailbox or retry later.': 'We\'ve recently sent a password reset request. Please check your mailbox or retry later.',
            
            'Your password cannot be the same as the previously used passwords.':'Your password cannot be the same as the previously used passwords.',
            'Your password doesn\'t meet the requirements. It must not match previous passwords or commonly used passwords.': 'Your password doesn\'t meet the requirements. It must not match previous passwords or commonly used passwords.',
        },
        optional: 'OPTIONAL, enroll additional factors:',
        or: 'OR',
        'Password should not contain three consecutive identical characters': 'Password should not contain more than 2 identical consecutive characters',
        'Password should not contain three consecutive sequential characters': 'Password should not contain more than 2 sequential characters',
        passwordLessLogin: 'LOG IN WITH EMAIL',
        privacy: 'PRIVACY',
        pw: 'Password',
        pwContainsConsecutiveChars: 'Password contains repeated characters',
        pwContainsSequentialChars: 'Password contains character sequences',
        pwFlow: {
            alsoContain: 'Also, does not contain:',
            anyLastPw: 'Any of your last 8 passwords',
            characterLengthText: 'Be at least 8 characters long',
            characterLengthTextNew: 'Be at least 8 characters long',
            charNumText: 'Include numbers',
            charNumTextNew: 'Include numbers',
            confirmPw: 'Confirm Password',
            criteriaError: 'Password criteria not met',
            firstNameError: 'Password contains part of your first name',
            lastNameError: 'Password contains part of your last name',
            loginError: 'Password contains part of your username',
            lowerUpperCaseText: 'Include uppercase and lowercase letters',
            lowerUpperCaseTextNew: 'Include uppercase and lowercase letters',
            matchError: 'Passwords do not match',
            notContainFnameLname: 'Part of your first name or last name',
            otherCriteria: 'Note: We\'ll also verify your password isn\'t too easy to guess and hasn\'t been used before.',
            partOfyourUsername: 'Part of your username or email address',
            partOfyourUsernameEmail: 'Not contain your username, email, or \n name',
            password: 'Password',
            passwordCannotContains: 'Your password cannot:',
            passwordContains: 'Your password must:', 
            pwReq10: 'Three (3) or more identical characters that appear consecutively (e.g. rrr000)',
            pwReq11: 'Ascending or descending sequencing beyond two (2) consecutive characters (e.g. 123abc, 098qwerty)',
            repeatedChars:'Not have 3+ repeated characters \n (aaa, 111)',
            sequence: 'Not use sequences (123, abc, xyz)',
            sequenceforgotpwd: 'Not use sequences (123, abc, xyz)',
            setupPw: 'Set Up Password',
            specialCharTextNew: 'Include special characters (@#$%^&*())',
            stepVerbiage: 'We require you to setup a permanent password for access to the RBC Capital Markets Online Portal. Please keep your password secure and update periodically.',
            toggleConfirmPw: 'toggle confirm password visibility',
            togglePw: 'toggle password visibility',
        },
        rbccmLink: 'https://www.rbccm.com/en/',
        rbccmTitle: 'Digital Marketplace',
        rbcdx: {
            loginTitle: 'RBCDX',
            new: 'NEW',
            qrBoxTitle: 'Now Available on Mobile',
            welcomeHeaderDesc: 'RBC DX is our multi-asset class trading platform that provides seamless navigation between products. Efficiently trade FX, money markets, bonds and deposits all through one advanced system.',
            welcomeHeaderTitle: 'Where Ideas are Executed.',
        },
        recaptchaError: 'Please verify using the reCAPTCHA',
        recoveryValidation: {
            resendSuccessMsg: 'Verification Code has been resent'
        },
        registrationAnalytics: {
            cancel: 'Cancel',
            companyname: 'Company Name',
            countryCode: 'Country Code',
            email: 'Email',
            entercaptcha: 'Enter Captcha',
            exit: 'Back to Sign In',
            ext: 'Ext#',
            firstname: 'First Name',
            interestedIN: 'Interested In',
            language: 'Preferred Language',
            lastname: 'Last Name',
            noData: 'No results found.',
            phonenumber: 'Phone Number',
            submit: 'Submit',
            success: 'Request Submitted',
            successVerbiage: 'Thank you for your interest in Multi-Asset Trade Analytics.\n \n  Please allow our team to review your request. If you do not receive a response, please reach out to your RBC coverage or email ',
            title: 'Request Access',
            verbiage: 'Please enter your information below to request access.'
        },
        registrationDefault: {
            back: 'Back',
            comments: 'Comments',
            continue: 'continue',
            maxComments: 'Maximum 255 characters allowed',
            successVerbiage: 'Thank you for your interest in Structured Edge. We will review your request. If you do not receive a response, please reach out to your Sales Representative.',
            verbiage: 'Please enter your information & select continue.',
            verbiage2: 'Please select your areas of interest to help us connect you with the correct sales representative.',
            verbiage3: 'DIGITAL PRODUCTS'
        },
        registrationFlow: {
            appsText: 'Log in to the RBC Digital Marketplace with your new credentials',
            callVerbiage: 'We have contacted you via Voice Call to deliver a verification code to the following number {{phoneNumber}}{{phoneExtension}}. Please enter the code below.',
            callVerificationCode: 'CALL Verification',
            code: 'Code',
            enterYourCode: 'Enter your code',
            helpText: 'If you need help, please contact your RBC sales representative.',
            incorrectVerificationCode: 'Incorrect Verification Code',
            loginText: 'Each application login has its own unique link. \nSave your favourites on the next page for faster access later.',
            mfa: 'Multi-factor authentication',
            recoveryTitle: 'How would you like to receive your verification code?',
            registrationSuccess: 'Registration successful!',
            resendSuccessMsg: 'Verification Code has been resent',
            resendVerificationCode: 'Resend code',
            setPassword: 'Create your password',
            setPasswordVerbiage: 'Set up a secure password following our requirements.',
            smsVerbiage: 'We have sent an SMS code to {{phoneNumber}} to verify your identity.\n Please enter the code below.',
            smsVerificationCode: 'SMS Verification',
            verbiage: 'Enter the code displayed in {{verbiage}} and click <i>Verify</i> button.',
            verbiage1: 'We offer Two-Factor Authentication to provide additional security. We encourage the use of Two-Factor Authentication. If you choose <i>not</i> to enroll now, you will have the opportunity to enroll at a later time. \n \n If you would like to enroll for MFA, please click <i>Enroll.</i> \n If you prefer to skip this step, please click <i>Finish.</i>',
            verbiage2: 'You can configure additional factors or click <i>Finish.</i>',
            verbiage3: 'Please select your preferred MFA provider from the list of options. Click <i>Setup</i> button on the right to enroll. Please click <i>Finish</i> if you would like to skip it at this time.',
            verbiage4: 'Please click <i>Let\'s Get Started</i> to initiate the registration process and activate your account.',
            verbiage5: 'A verification code has been sent via {{recoveryType}} to: {{phoneNumber}}.Please enter the code below.',
            verificationCode: 'Verification Code',
            verificationSuccess: 'Verification successful!',
            phoneSetupTitle: 'Set up phone number for identity verification',
            phoneSetupDescription: 'To keep your account secure, please provide the phone number you\'d like to use for identity verification.',
            phoneSetupUpdateDescription: 'To keep your account secure, please provide the phone numbers you\'d like to use for identity verification.',
            recoveryType: 'Recovery Type',
            recoveryTypeOption_sms: 'SMS',
            recoveryTypeOption_call: 'Call',
            countryCode: 'Country Code',
            phoneNumber: 'Phone Number',
            extension: 'Extension (Optional)',
            selectType: 'Select',
            selectCode: 'Select',
            recoveryTypeRequired: 'Please select a recovery type.',
            countryCodeRequired: 'Please select the country code.',
            phoneNumberRequired: 'Please enter a phone number.',
            phoneNumberMinLength: 'Phone number must be at least 7 digits',
            phoneNumberMaxLength: 'Phone number must not exceed 15 digits',
            phoneNumberInvalid: 'Invalid phone number for the selected country code.',
            smsCapablePhoneRequired: 'Please enter a mobile phone number that can receive SMS messages.',
        },
        
        registrationWelcome: {
            card1desc:'Have your phone ready to receive a verification code.',
            card1Title: 'Verify your identity',
            card2desc:'Choose a strong password.',
            card2Title: 'Create your password',
            card3desc:'Add an extra layer of security.',
            card3Title: 'Set-up multi-factor authentication',
            hedgexSubtitle: 'Please make sure you are ready to complete the process before selecting Get Started.',
            aagSubtitle: 'Please make sure you are ready to complete the process before selecting Get Started.',
            mainSubtitle: 'This link can be used only once. Please make sure you are ready to complete the process before selecting Get Started.',
            mainTitle: 'Complete your registration in 3 steps',
        },
        rememberMe: 'Remember me',
        rememberMyUserId: 'Remember my User ID',
        requestAcess: 'Request Access',
        required: 'required',
        resend: 'Resend',
        securityWarning: {
            content: 'There is an issue with your session. You may be switching your network connection. Please retry by logging in again.',
            title: 'Session Integrity Issue'
        },
        sessionTimeout: 'Session Timeout',
        sessionTimeoutInactivity: 'You do not have a valid session or your session has expired due to inactivity.',
        sessionTimeoutMagicLink: 'Your session has expired due to inactivity.\n Return to login page to request a new link.',
        sessionTimeoutOneMin: 'Your session will expire in 1 minute. Will you like to extend the session?',
        sessionTimeoutWithTime: 'Your session has expired due to inactivity of {{time}} minute(s).',
        passwordChanged: {
            loginHere: 'Login here',
            title: 'Password Change Successful',
            verbiage: 'We have updated your password and logged you out from RBC Capital Markets Client Portal. Please use the following link to login again with your new password.'
        },
        setup: 'Setup',
        signIn: 'Sign In',
        signInAuth: {
            multifactor: 'Multi-Factor Authentication (MFA)',
            select: 'Select',
            verbiage1: 'You have more than one login factor setup. Please choose a factor to use from the list below.'
        },
        signInBack: {
            newQuickSignIn: 'Or use the quick link to launch your app directly',
            quickSignIn: 'Quick Sign In for Apps:',
            signBackIn: 'Sign back in',
            verbiage1: 'Your RBC Capital Markets Online portal registration process is completed. Please sign back in to access your application'
        },
        'SMS': 'SMS',
        somethingWentWrong: 'Something Went Wrong',
        sms: 'SMS',
        ssoError: {
            title: 'You are not enrolled for access',
            verbiage: 'Your account is not enrolled for access to this application. Please speak with your RBC Salesperson to request access or learn more about the application.'
        },
        successPage: {
            quickSignIn: 'Quick Sign In for Apps:',
            title: 'Thank you for choosing \n RBC Capital Markets',
            verbiage: 'Your RBC Capital Markets Online portal password has been updated. Please sign back in to access your application.'
        },
        userId: 'User ID',
        verificationDevType: 'How would you like to receive your verification code?',
        verificationMethod: 'Verification Method',
        verificationType: 'Please select your how you want to verify yourself today.',
        verify: 'Verify',
        'Voice Call': 'Voice Call',
        welcome: 'Welcome to RBC Capital Markets',
        welcomeHeaderDescGeneral: 'Please login to connect with RBC products.',
        welcomeHeaderDescGeneralTop: 'RBC Digital Marketplace',
        welcomeHeaderTitleGeneral: 'Welcome to \n'
    }
}
